export default __webpack_public_path__ + "static/media/who-are-we.e3840478.jpeg";